'use client';

import { ComponentPropsWithRef, useState } from 'react';
import { Icon } from '@/shared/ui/icon';
import './field.scss';
import { TextField } from './text-field';

type Props = Omit<ComponentPropsWithRef<typeof TextField>, 'type' | 'right'>;
export const PasswordField = (props: Props) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <TextField
            type={isVisible ? 'text' : 'password'}
            right={
                <button
                    type="button"
                    onClick={() => setIsVisible((prev) => !prev)}
                    className="field__icon-btn"
                    aria-label={isVisible ? 'Hide password' : 'Show password'}
                >
                    {isVisible ? <Icon name="eye-off" /> : <Icon name="eye" />}
                </button>
            }
            {...props}
        />
    );
};
